import { Component, Input } from '@angular/core';
import { TIME_FORMAT } from 'src/app/core/ccomx-date-formats';
import { chemicalExposureLogUsers } from 'src/app/storage-user/functions/chemical-exposure-log-users';
import { chemicalExposureRegisteredByName } from 'src/app/storage-user/functions/chemical-exposure-registered-by-name';
import { chemicalExposurePlacementLabel } from 'src/app/storage-user/functions/chemical-exposure-placement-label';
import { formatChemicalExposureAmount } from 'src/app/storage-user/functions/format-chemical-exposure-amount';
import { IUserChemicalExposureLogItem } from 'src/app/storage-user/models/chemical-exposure.model';

@Component({
  selector: 'app-chemical-exposure-log-template',
  templateUrl: './chemical-exposure-log-template.component.html',
  styleUrls: ['./chemical-exposure-log-template.component.scss'],
  standalone: false,
})
export class ChemicalExposureLogTemplateComponent {
  @Input() columnName: string;
  @Input() element: IUserChemicalExposureLogItem;

  readonly timeFormat = TIME_FORMAT;

  get placementKey(): string {
    return chemicalExposurePlacementLabel(this.element?.exposurePlacement);
  }

  get peopleNames(): string {
    const names = this.element
      ? chemicalExposureLogUsers(this.element)
          .map((person) => person.name)
          .filter((name) => !!name)
      : [];
    return names.length ? names.join(', ') : '-';
  }

  get amountDisplay(): string {
    return formatChemicalExposureAmount(this.element);
  }

  get registeredByName(): string {
    return chemicalExposureRegisteredByName(this.element) || '-';
  }

  get positionNames(): string {
    const names = (this.element?.exposedPositions ?? []).filter((name) => !!name);
    return names.length ? names.join(', ') : '-';
  }
}
